import { PluginSlugs } from '../../../config';
import { PluginDependencyGroup } from '../../domain';
import { IntegrationTypes } from '../integration';

export const DEPENDENCIES_BY_PLUGIN: Record<string, PluginDependencyGroup[]> = {
    [PluginSlugs.VAROSTEST]: [
        {
            definitions: [{ kind: IntegrationTypes.VAROSTEST }],
        },
    ],
    [PluginSlugs.LINKEDIN]: [
        {
            definitions: [{ kind: IntegrationTypes.LINKEDIN }],
        },
    ],
    [PluginSlugs.FACEBOOKADS]: [
        {
            definitions: [{ kind: IntegrationTypes.FACEBOOK }],
        },
    ],
    [PluginSlugs.GOOGLEADS]: [
        {
            definitions: [{ kind: IntegrationTypes.GOOGLE }],
        },
    ],
    [PluginSlugs.TIKTOKADS]: [
        {
            definitions: [{ kind: IntegrationTypes.TIKTOK }],
        },
    ],
    [PluginSlugs.GOOGLE_ANALYTICS]: [
        {
            definitions: [{ kind: IntegrationTypes.GOOGLE_ANALYTICS }],
        },
    ],
    [PluginSlugs.SHOPIFY]: [
        {
            definitions: [{ kind: IntegrationTypes.SHOPIFY }],
        },
    ],
    [PluginSlugs.EXECUTIVE_SUMMARY]: [
        {
            definitions: [{ kind: IntegrationTypes.SHOPIFY }],
        },
        {
            definitions: [
                { kind: IntegrationTypes.FACEBOOK },
                { kind: IntegrationTypes.GOOGLE },
                { kind: IntegrationTypes.TIKTOK },
            ],
        },
    ],
};
